import React,{useEffect} from 'react'
import {useLocation } from 'react-router-dom';
import Banner from '../Components/PrimaryComponents/Banner/Banner'
import School from '../Components/PrimaryComponents/School/School'
import Testimonials from '../Components/PrimaryComponents/TestimonialsSchool/TestimonialsSchool'
import Programme from '../Components/PrimaryComponents/Programme/Programme'
import Choice from '../Components/PrimaryComponents/Choice/Choice'
import Curriculum from '../Components/PrimaryComponents/Curriculum/Curriculum'
import Faculties from '../Components/PrimaryComponents/Faculties/Faculties'
import AdminssionPre from '../Components/PrimaryComponents/AdmissionPre/AdmissionPre'
import Information from '../Components/PrimaryComponents/Information/Information'
// import SuccessStory from '../Components/PrimaryComponents/SuccessStory/SuccessStory'
import Gallery from '../Components/PrimaryComponents/Gallery/Gallery'
import Transportation from '../Components/PrimaryComponents/Transportation/Transportation'
import Apply from '../Components/PrimaryComponents/Apply/Apply'
import OtherSections from '../Components/PrimaryComponents/OtherSections/OtherSections'
import ReactGA from "react-ga4";

ReactGA.initialize("G-KE1087VQ84");

ReactGA.send({ hitType: "pageview", 
                page: window.location.pathname, });
const Primary = () => {
  const ScrollToTop = () => {
    const { pathname, state } = useLocation();
  
    useEffect(() => {
      setTimeout(() => {
        window.scrollTo(0, 0);
        if (state && state.targetSection) {
          const targetSection = document.querySelector(state.targetSection);
          if (targetSection) {
            targetSection.scrollIntoView({ behavior: 'smooth' });
          }
        }
      }, 100); // Adding a slight delay to ensure scroll happens after the render
    }, [pathname, state]);
  
    return null;
  };
  return (
    <div>
           <ScrollToTop/>
      <Banner/>
      <School/>
      <Programme/>
      <Choice/>
      <Curriculum/>
      <Faculties/>
      <AdminssionPre/>
      <Information/>
      {/* <SuccessStory/> */}
      <Testimonials/>
      <Gallery/>
      <Transportation/>
      <Apply/>
      <OtherSections/>
      
    </div>
  )
}

export default Primary
